import ContratoServicios from '../../components/forms/subcribirseForm/contratoServicios/ContratoServicios';
import '../../index.css'

function ContratosFacturasPag() {
  return (
    <div className='pt-20'>
     <ContratoServicios paymentOption={''} />

    </div>
   
  );
};

export default ContratosFacturasPag
